import type { FilePondFile } from 'filepond';
import type { FilePond } from 'react-filepond';
import type { File } from 'src/components/moleculesLegacy/FileUpload';
import { UploadScanStatus } from 'src/types';

export function mapPondFilesToEvidenceUploadFiles(pond: FilePond): File[] {
  const timestamp = new Date().toISOString();
  return pond
    .getFiles()
    .map((x: FilePondFile & { created?: string }) => ({
      source: String(x.serverId ?? '').replaceAll('"', ''),
      options: {
        type: 'local' as const,
        file: {
          name: x.filename,
          size: x.fileSize,
          type: x.fileType,
        },
        metadata: {
          scanStatus: x.getMetadata('scanStatus') || UploadScanStatus.PENDING,
          ...(x.getMetadata('qaAttachmentId')
            ? { qaAttachmentId: String(x.getMetadata('qaAttachmentId')) }
            : {}),
        },
      },
      status: x.status,
      created: x.created ?? timestamp,
      updated: timestamp,
    }))
    .filter((x) => x.source !== '');
}
